import React, { useState } from 'react';

import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react';
import { uniqWith } from 'ramda';
import { UploadFilesPicker, UploadIconButton } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { FileStackDomContainer, partyTypename } from 'src/helpers';

export function UploadDocumentsButton({ partyId }: { partyId: UUID }): JSX.Element {
  const client = useApolloClient();
  const partyDocumentsKey: keyof Apollo.Party = 'documents';
  const [filePickerOpen, setFilePickerOpen] = useState(false);

  return (
    <>
      <UploadIconButton
        appearance="filled"
        tooltip="Upload"
        onClick={() => setFilePickerOpen(!filePickerOpen)}
      />
      <UploadFilesPicker
        domContainer={FileStackDomContainer.PartyDocuments}
        open={filePickerOpen}
        pickerOpts={{
          afterUploadDone: ({ data }) => {
            setFilePickerOpen(false);
            client.cache.modify({
              fields: {
                [partyDocumentsKey]: (refs = [], { readField }) => {
                  const newRefs =
                    data?.createFiles.flatMap(document => {
                      const ref = client.cache.writeFragment({
                        data: document,
                        fragment: gql`
                          fragment NewDocument on Document {
                            __typename
                            id
                          }
                        `,
                      });
                      return ref ? [ref] : [];
                    }) ?? [];

                  return uniqWith(
                    (a, b) => readField<UUID>('id', a) === readField<UUID>('id', b),
                    [...refs, ...newRefs]
                  );
                },
              },
              id: client.cache.identify({ __typename: partyTypename, id: partyId }),
            });
          },
          onClose: () => setFilePickerOpen(false),
          props: {
            documentVariant: Apollo.DocumentVariant.Document,
            isSigned: false,
            partyIds: [partyId],
          },
        }}
      />
    </>
  );
}
